/**
 * Generates a URL to the flow builder page.
 * @param chatBotFlowId - The bot's flow ID.
 * @returns The relative route string (e.g. /admin/automation/flow/123).
 */
export const getFlowConstructorRoute = (chatBotFlowId: number | string): string => {
	return `/admin/automation/flow/${chatBotFlowId}`
}
